/**
 * Library size figures used in user-facing marketing copy.
 *
 * Values are rounded DOWN from the real counts so they stay true as the library
 * grows and can never overstate. These hold the bare number only. Call sites
 * add their own "over ..." or "...+" so we never end up with "over 12,000+".
 *
 * The query for updating the numbers can be found in
 * https://github.com/shortformhq/main/issues/20405#issuecomment-5869067728
 *
 * Last refreshed: 2026-09-30.
 * Actual counts at that time —
 * - books: 12,191
 * - articles: 1,382
 * - books + articles: 13,573
 * - podcast episodes: 10,570 (across 250 shows).
 */
export const ContentStats = {
  /**
   * Books only. Use where the copy says "books" specifically.
   */
  books: '12,000',

  /**
   * Articles and topic guides only.
   */
  articles: '1,000',

  /**
   * Books + articles, the figure behind broad "guides"/"summaries" claims.
   * Deliberately excludes podcast episodes.
   */
  guides: '13,000',
} as const
